import { Link } from 'react-router';
import { Workspace } from '../components/Workspace';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { pasteForgotten, selectOwnedPastes } from '../features/owned/ownedPastesSlice';

/** Pastes created in this browser (the ones it holds delete tokens for). */
export function MyPastesPage() {
  const pastes = useAppSelector(selectOwnedPastes);
  const dispatch = useAppDispatch();

  return (
    <Workspace title="My pastes">
      <article className="page">
      <header>
        <h1>My pastes</h1>
      </header>
      {pastes.length === 0 ? (
        <p>
          You have not created any pastes in this browser yet. <Link to="/">Create one</Link>
        </p>
      ) : (
        <table>
          <thead>
            <tr>
              <th scope="col">Paste</th>
              <th scope="col">Created</th>
              <th scope="col">
                <span className="visually-hidden">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {pastes.map((paste) => (
              <tr key={paste.id}>
                <td>
                  <Link to={`/p/${paste.id}`}>{paste.title ?? (paste.preview || paste.id)}</Link>
                </td>
                <td>
                  <time dateTime={paste.createdAt}>{new Date(paste.createdAt).toLocaleString()}</time>
                </td>
                <td>
                  <button
                    type="button"
                    className="secondary outline"
                    title="Removes the delete token from this browser; the paste stays online"
                    onClick={() => dispatch(pasteForgotten(paste.id))}
                  >
                    Forget
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      </article>
    </Workspace>
  );
}
